import {contactUs} from '../services/common';

export const startContactUs = (body) => {
    return (dispatch, getState) => {
        return contactUs({body})
            .then((response) => {
                return {
                    success: {
                        status: response.status,
                        body: response.data
                    }
                };
            })
            .catch((error) => {
                return {
                    error: {
                        status: error.response.status,
                        body: error.response.data
                    }
                };
            })
    }
}